const agb = {
  policyMessage: 'Die {link} der IhreApotheken GmbH & Co. KGaA habe ich zur Kenntnis genommen und bin mit deren Geltung einverstanden.',
  dataProtectionMessage: 'Mein Nutzerkonto soll mir wie gehabt mit allen Informationen zu mir und meinen Bestellungen zur Verfügung stehen. Die {link} der IhreApotheken GmbH & Co. KGaA habe ich zur Kenntnis genommen.',
  termsOfUse: 'Nutzungsbedingungen',
  privacyPolicy: 'Datenschutzhinweise',
  errorUpdatePolicy: 'Fehler beim Aktualisieren von Richtlinien.',
  thankYouMessage: 'Vielen Dank!',
  welcomeMessage: 'Herzlich willkommen!',
  cancel: 'Abbrechen',
  accept: 'Akzeptieren',
  approvalMessage: 'Wir haben unsere Nutzungsbedingungen und Datenschutzhinweise angepasst. Um Ihnen Ihr Nutzerkonto unverändert zur Verfügung stellen zu können, bitten wir Sie um folgende Zustimmungen:',
}

export default agb
